var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 4,
    fill: "#F3A72D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8047 8.20553C19.0011 8.0091 19.2343 7.85327 19.491 7.74696C19.7476 7.64065 20.0227 7.58594 20.3005 7.58594C20.5783 7.58594 20.8534 7.64065 21.11 7.74696C21.3667 7.85327 21.5999 8.0091 21.7963 8.20553C21.9928 8.40197 22.1486 8.63517 22.2549 8.89183C22.3612 9.14848 22.4159 9.42356 22.4159 9.70136C22.4159 9.97917 22.3612 10.2542 22.2549 10.5109C22.1486 10.7676 21.9928 11.0008 21.7963 11.1972L11.6995 21.2941L7.58594 22.4159L8.70781 18.3024L18.8047 8.20553Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.b076bf5bd57a415c0b96d345552d644d.svg";
export { ForwardRef as ReactComponent };